import React, { useState, useEffect } from 'react'
import { Box, Paper, Text, Flex, Tooltip, ThemeIcon, Skeleton, CopyButton, Button, Group } from '@mantine/core'
import { IconCheck, IconCopy, IconWindowMaximize } from '@tabler/icons-react'
import { useSelector, useDispatch } from 'react-redux'
import { generateShortUrlOrder } from '../../../../../services/orders'
import { updateOrderSummary } from '../../../../../store/orderDetail'

const FormShareSalesOrder = ({ idOrder, onCloseModal }) => {
  const dispatch = useDispatch()
  const { summary } = useSelector(state => state.order_detail)
  const [loadingShortLink, setLoadingShortLink] = useState(false)
  const [shortLinkURL, setShortLinkURL] = useState(null)

  const generateShortUrl = async (orderId) => {
    setLoadingShortLink(true)
    try {
      const response = await generateShortUrlOrder(orderId)
      if (response.success) {
        const shortUrl = response.data.short_url
        setShortLinkURL(shortUrl)
        const updatedSummary = {
          ...summary,
          shortUrl
        }
        dispatch(updateOrderSummary(updatedSummary))
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingShortLink(false)
    }
  }

  useEffect(() => {
    handleSetState(summary)
  }, [summary])

  const handleSetState = (value) => {
    setShortLinkURL(value.shortUrl)
  }

  const openNewTab = (url) => {
    window.open(`${url}`, '_blank')
  }

  const mappingShortLinkUrl = (dataUrl) => {
    if (dataUrl === null) {
      return (
        <Box ta='center'>
          <Button size='compact-xs' variant='transparent' color='blue.9' onClick={() => generateShortUrl(idOrder)}>Click to Generate Short Link</Button>
        </Box>
      )
    } else {
      return (
        <Flex gap={4} align='center'>
          <Text fz={12} c='blue.9'>{`${dataUrl}`}</Text>
          <CopyButton value={`${dataUrl}`} timeout={2000}>
            {({ copied, copy }) => (
              <Tooltip label={copied ? 'Copied' : 'Copy'} withArrow position="top">
                <ThemeIcon color={copied ? 'teal' : 'blue.9'} variant="subtle" onClick={copy} size='xs'>
                  {copied ? <IconCheck size={12} /> : <IconCopy size={12} />}
                </ThemeIcon>
              </Tooltip>
            )}
          </CopyButton>
          <Tooltip label='Open Link' withArrow position="top">
            <ThemeIcon color='blue.9' variant="subtle" size='xs' onClick={() => openNewTab(`${dataUrl}`)}>
              <IconWindowMaximize size={12} />
            </ThemeIcon>
          </Tooltip>
        </Flex>
      )
    }
  }


  return (
    <Box>
      <Paper shadow="sm" withBorder p="sm" mb='lg'>
        <Text fz={14} fw='600' mb={12}>Sales Order / quote URL for User</Text>
        <Box mb='xs'>
          <Text fz={12} fw='500' c='gray.6' mb={1}>EN URL:</Text>
          <Flex gap={4} align='center'>
            <Text fz={12} c='blue.9' truncate='end'>{`${summary.invoiceUrl}`}</Text>
            <CopyButton value={`${summary.invoiceUrl}`} timeout={2000}>
              {({ copied, copy }) => (
                <Tooltip label={copied ? 'Copied' : 'Copy'} withArrow position="top">
                  <ThemeIcon color={copied ? 'teal' : 'blue.9'} variant="subtle" onClick={copy} size='xs'>
                    {copied ? <IconCheck size={12} /> : <IconCopy size={12} />}
                  </ThemeIcon>
                </Tooltip>
              )}
            </CopyButton>
            <Tooltip label='Open Link' withArrow position="top">
              <ThemeIcon color='blue.9' variant="subtle" size='xs' onClick={() => openNewTab(`${summary.invoiceUrl}`)}>
                <IconWindowMaximize size={12} />
              </ThemeIcon>
            </Tooltip>
          </Flex>
        </Box>
        <Box mb='md'>
          <Text fz={12} fw='500' c='gray.6' mb={1}>Short URL:</Text>
          {loadingShortLink ? <Box w={100}><Skeleton height={14} radius="xl" /></Box> : mappingShortLinkUrl(shortLinkURL)}
        </Box>
      </Paper>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseModal}>Close</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormShareSalesOrder